import React from "react";

import { COLORS } from "@tSurya/theme/design.mgbw";

const MGBWUserIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g transform="translate(1.86, 0.53)">
                <path d="M8.09375 8.125C10.4062 8.125 12.2813 6.3125 12.2813 4.0625C12.2813 1.8125 10.4062 0 8.09375 0C5.78125 0 3.90625 1.8125 3.90625 4.0625C3.90625 6.3125 5.78125 8.125 8.09375 8.125ZM8.09375 1.4375C9.625 1.4375 10.875 2.625 10.875 4.09375C10.875 5.5625 9.625 6.75 8.09375 6.75C6.5625 6.75 5.3125 5.5625 5.3125 4.09375C5.3125 2.625 6.5625 1.4375 8.09375 1.4375Z" fill={COLORS.primary.base}/>
                <path d="M10.125 9.53125H6.0625C2.71875 9.53125 0 12.2813 0 15.625V18.2188C0 18.5938 0.3125 18.9375 0.71875 18.9375C1.125 18.9375 1.4375 18.625 1.4375 18.2188V15.625C1.4375 13.0625 3.53125 10.9375 6.125 10.9375H10.1563C12.7188 10.9375 14.8438 13.0313 14.8438 15.625V18.2188C14.8438 18.5938 15.1563 18.9375 15.5625 18.9375C15.9688 18.9375 16.2813 18.625 16.2813 18.2188V15.625C16.1875 12.2813 13.4688 9.53125 10.125 9.53125Z" fill={COLORS.primary.base}/>
            </g>
        </svg>
    );
};

export default React.memo(MGBWUserIcon);
